import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageTitle } from "@/components/Bits";
import { EmpAvatar } from "@/components/EmpAvatar";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, Mail, Phone, Settings2 } from "lucide-react";

export default function Directory() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const navigate = useNavigate();
  const [people, setPeople] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/directory").then((r) => setPeople(r.data)).catch(() => {}); }, []);

  const shown = people.filter((p) =>
    !q || p.full_name.toLowerCase().includes(q.toLowerCase()) ||
    (p.position || "").toLowerCase().includes(q.toLowerCase()) ||
    (p.department || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="animate-fade-up">
      <PageTitle overline="Company" title="Staff Directory">
        {isAdmin && (
          <Button variant="outline" onClick={() => navigate("/employees")} data-testid="directory-manage-btn">
            <Settings2 className="h-4 w-4 mr-1.5" /> Manage in Employees
          </Button>
        )}
      </PageTitle>
      <div className="relative max-w-sm mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, title, department" className="pl-9" data-testid="directory-search" />
      </div>
      {shown.length === 0 ? (
        <p className="text-muted-foreground" data-testid="directory-empty">No staff listed in the directory yet.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {shown.map((p) => (
            <Card key={p.id} className="p-5 rounded-md border-border flex items-center gap-4" data-testid={`directory-card-${p.id}`}>
              <EmpAvatar emp={p} size="h-14 w-14" />
              <div className="min-w-0">
                <p className="font-heading font-bold truncate">{p.full_name}</p>
                <p className="text-sm text-muted-foreground truncate">{p.position || p.role}{p.department ? ` · ${p.department}` : ""}</p>
                <div className="flex gap-3 mt-1.5">
                  {p.company_email && <a href={`mailto:${p.company_email}`} className="text-primary inline-flex items-center gap-1 text-xs" data-testid={`directory-email-${p.id}`}><Mail className="h-3.5 w-3.5" /> Email</a>}
                  {p.company_number && <span className="text-muted-foreground inline-flex items-center gap-1 text-xs"><Phone className="h-3.5 w-3.5" /> {p.company_number}</span>}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
